import { destroy as destroyForm, change } from 'redux-form'
import isEmpty from 'lodash/isEmpty'
import isUndefined from 'lodash/isUndefined'
import get from 'lodash/get'
import find from 'lodash/find'
import castArray from 'lodash/castArray'
import first from 'lodash/first'
import { CustomFieldsGroup } from '@lk/api'
import createAction from 'loankeeper-common/helpers/createAction'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'
import { fetchSFM, destroy as destroyFetcher } from 'loankeeper-common/helpers/SimpleFetchManager'
import { actions as LKModalActions } from '../../LKModal'
import { Print } from '../../../../WebAPI'

import { loadCustomFields, customFieldsAttributesToString } from '../../../../store/customFields'
import actions, { RESET } from './actionTypes'
import {
  APPLICATION_ADD_FETCHER_NAME,
  SEARCH_CLIENT_FETCHER_NAME,
  CLIENT_VIEW_BASE_FETCHER_NAME,
  CLIENT_VIEW_BASE2_FETCHER_NAME,
  CLIENT_VIEW_BASE3_FETCHER_NAME,
  // APP_VIEW_BASE_FETCHER_NAME,
  APP_VIEW_CUSTOM_DYNAMIC_FIELD_FETCHER_NAME,
  FORM_NAME,
  CLIENT_VALIDATION_FETCHER_NAME,
  APP_ADD_CLIENT_EDIT_MODAL_NAME,
  APP_EDIT_CLIENT_EDIT_MODAL_NAME,
  APPLICATION_EDIT_FETCHER_NAME,
  APP_VIEW_DECISION_ELIGIBLE_FETCHER_NAME,
  APP_ADD_INSTANCE_NAME,
  APP_EDIT_INSTANCE_NAME,
  APP_EDIT_CLIENT_WATCHLIST_MODAL_NAME,
} from '../constants'

import { getSearchPanelConfig, translateLKMessage } from '../helpers'

import {
  isProductViewListValid,
  isClientViewBaseValidTest,
  getIndustrySubIDOptionsSource,
  getIndustrySubIDOptionsFromSource,
  getIndustrySubDetailOptionsSource,
  getIndustrySubDetailOptionsFromSource,
  getDropdownFirstValue,
} from '../Components/helpers'
import { loadProductListIfNeeded, loadProductDetailsIfNeeded, getProductDetailsById } from 'src/store/product'
import { formValueSelector } from '../helpers'
import {
  applicationViewBase,
  applicationViewBic,
  applicationViewCustfields,
  destroyApplicationViewBase,
} from 'src/store/application'
import { checkReqFields as checkReqFieldsAction, clientSearch, destroyReqFields } from 'src/store/client'

export const resetReducer = () => createAction(RESET)

export const destroy = () => [
  resetReducer(),

  destroyForm(FORM_NAME),

  destroyFetcher(SEARCH_CLIENT_FETCHER_NAME),
  destroyFetcher(CLIENT_VIEW_BASE_FETCHER_NAME),
  destroyFetcher(CLIENT_VIEW_BASE2_FETCHER_NAME),
  destroyFetcher(CLIENT_VIEW_BASE3_FETCHER_NAME),
  // destroyFetcher(APP_VIEW_BASE_FETCHER_NAME),
  destroyApplicationViewBase(),
  destroyFetcher(APP_VIEW_DECISION_ELIGIBLE_FETCHER_NAME),
  // destroyFetcher(CLIENT_VALIDATION_FETCHER_NAME),
  destroyReqFields(),
  destroyFetcher(APPLICATION_ADD_FETCHER_NAME),
  destroyFetcher(APPLICATION_EDIT_FETCHER_NAME),
]

export const destroyClientFetcher2 = () => destroyFetcher(CLIENT_VIEW_BASE2_FETCHER_NAME)

export const destroyClientFetcher3 = () => destroyFetcher(CLIENT_VIEW_BASE3_FETCHER_NAME)

// order is important
export const close = (instanceName) => [LKModalActions.close(instanceName), ...destroy()]

export const setProductId = (id) => createAction(actions.SET_PRODUCT_ID, id)

export const industrySubIDOptionsSourceSet = (newValue) =>
  createAction(actions.industrySubIDOptionsSource.SET, newValue)
export const industrySubIDOptionsSourceDelete = () => createAction(actions.industrySubIDOptionsSource.DELETE)

export const industrySubDetailOptionsSourceSet = (newValue) =>
  createAction(actions.industrySubDetailOptionsSource.SET, newValue)
export const industrySubDetailOptionsSourceDelete = () => createAction(actions.industrySubDetailOptionsSource.DELETE)

export const loanEndDateSet = (newValue) => createAction(actions.loanEndDate.SET, newValue)
export const loanEndDateDelete = () => createAction(actions.loanEndDate.DELETE)

export const reqCurrencyValDataSet = (newValue) => createAction(actions.reqCurrencyValData.SET, newValue)
export const reqCurrencyValDataDelete = () => createAction(actions.reqCurrencyValData.DELETE)

export const fetchClientViewBase = (ID, hash, which) =>
  fetchSFM({
    instanceName:
      (which === 2 && CLIENT_VIEW_BASE2_FETCHER_NAME) ||
      (which === 3 && CLIENT_VIEW_BASE3_FETCHER_NAME) ||
      CLIENT_VIEW_BASE_FETCHER_NAME,
    callApi: Print.printClient,
    callApiArgs: [{ ClientID: ID, HashSum_ClientID_: hash, page: 'base' }],
    transformResponse: (response) => ({ ...response.Data, HashSum_ClientID_: hash }),
  })

// export const fetchClientValidation = (ID, hash, clientReqFieldGroupID) =>
//   fetchSFM({
//     instanceName: CLIENT_VALIDATION_FETCHER_NAME,
//     callApi: Client.checkReqFields,
//     callApiArgs: [{ ClientID: ID, HashSum_ClientID_: hash, ID: clientReqFieldGroupID }],
//     transformResponse: (valResponse) => valResponse.Data,
//   })

export const fetchClientValidationNew = (ID, hash, clientReqFieldGroupID) =>
  checkReqFieldsAction({
    ClientID: ID,
    HashSum_ClientID_: hash,
    ID: clientReqFieldGroupID,
  })

const fetchClientDependents = async (
  dispatch,
  client,
  clientReqFieldGroupID,
  which,
  productViewDetail,
  generalLookupsSys,
  checkReqFields = null,
) => {
  const { ID, HashSum_ClientID_, ClientType, CardNumber } = client

  let checkReqFieldsData
  if (!checkReqFields) {
    // checkReqFieldsData = await dispatch(fetchClientValidation(ID, HashSum_ClientID_, clientReqFieldGroupID))
    //UPDATED API REQUEST client_oper_api page: checkreqfields
    const reqfFieldsResponse = await dispatch(fetchClientValidationNew(ID, HashSum_ClientID_, clientReqFieldGroupID))
    if (!checkReqFieldsAction.fulfilled.match(reqfFieldsResponse)) {
      dispatch(LKModalActions.openError(translateLKMessage(reqfFieldsResponse.payload)))
      return
    }
    checkReqFieldsData = reqfFieldsResponse.payload
  } else {
    checkReqFieldsData = checkReqFields.Data
  }

  if (!isEmpty(checkReqFieldsData)) {
    dispatch(
      LKModalActions.openConfirmation(APP_ADD_CLIENT_EDIT_MODAL_NAME, {
        message: translateLKMessage('ERR_FILL_REQUIRED_FIELDS'),
        ID,
        hash: HashSum_ClientID_,
        ClientType,
        clientReqFieldGroupID,
        CardNumber,
        isPassPhraseRequired: false,
        code: 'ERR_FILL_REQUIRED_FIELDS',
        which,
      }),
    )
  } else {
    const clientView = await dispatch(fetchClientViewBase(ID, HashSum_ClientID_, which))

    if (
      which !== 2 &&
      which !== 3 &&
      productViewDetail.IndustryCheck === 2 &&
      productViewDetail.DefaultIndustryCheck === 0
    ) {
      dispatch(change(FORM_NAME, 'IndustryID', clientView.IndustryID))

      const industrySubIDOptionsSource = getIndustrySubIDOptionsSource(generalLookupsSys, clientView.IndustryID)
      const industrySubIDOptions = getIndustrySubIDOptionsFromSource(industrySubIDOptionsSource)

      dispatch(industrySubIDOptionsSourceSet(industrySubIDOptionsSource))

      if (!isEmpty(industrySubIDOptionsSource)) {
        const industrySubID = getDropdownFirstValue(industrySubIDOptions, true)
        dispatch(
          change(
            FORM_NAME,
            'IndustrySubID',
            industrySubIDOptions.some((o) => o.value === clientView.SubIndustryID)
              ? clientView.SubIndustryID
              : industrySubID,
          ),
        )

        const industrySubDetailOptionsSource = getIndustrySubDetailOptionsSource(
          generalLookupsSys,
          clientView.SubIndustryID,
        )
        const industrySubDetailOptions = getIndustrySubDetailOptionsFromSource(industrySubDetailOptionsSource)

        dispatch(industrySubDetailOptionsSourceSet(industrySubDetailOptionsSource))

        if (!isEmpty(industrySubDetailOptionsSource)) {
          dispatch(
            change(
              FORM_NAME,
              'IndustrySubDetailID',
              industrySubDetailOptions.some((o) => o.value === clientView.ORG_IndustrySubDetailID)
                ? clientView.ORG_IndustrySubDetailID
                : getDropdownFirstValue(industrySubDetailOptions, true),
            ),
          )
        }
      }
    }
  }
}

// export const destroyClientDependents = () => destroyFetcher(CLIENT_VALIDATION_FETCHER_NAME)
export const destroyClientDependents = () => destroyReqFields()

const toBitValue = (val) => (val ? '1' : '0')

const isID = (value) => typeof value === 'number'

const defineSearchFlags = ({ categ }) =>
  [toBitValue(categ.individuals), toBitValue(categ.solidarityGroups), toBitValue(categ.companies), '0001'].join('')

const getClientSearchData = (cardNumberInput, productViewDetail) => {
  const { initialValues } = getSearchPanelConfig(productViewDetail)

  const searchflags = defineSearchFlags(initialValues)

  const data = {
    page: 'searchexact',
    searchfield: 'personalno',
    searchvalue: cardNumberInput,
    searchflags,
  }

  if (isID(cardNumberInput)) {
    data.page = 'search'
    data.searchfield = 'name'
    data.searchvalue = `#${cardNumberInput}`
  }

  return [data]
}

export function fetchClientByCardNumber(
  cardNumberInput,
  which,
  generalLookupsSys,
  { client = null, checkReqFields, changedProductId } = {},
) {
  return async (dispatch, getState) => {
    const state = getState()

    const productId = changedProductId || formValueSelector(state, 'ProductID')

    const productViewDetail = getProductDetailsById(getState(), productId)
    const { Client_ReqField_GroupID } = productViewDetail

    if (!isID(cardNumberInput) && cardNumberInput.length < 1) {
      return null
    }

    const transformClientSearchData = ({ Data: Clients }) => {
      const clientNum = get(Clients, 'length')
      const clientByCardNumber = get(Clients, '[0]')

      return clientNum === 1 ? clientByCardNumber : null
    }

    if (client) {
      return fetchClientDependents(
        dispatch,
        client,
        Client_ReqField_GroupID,
        which,
        productViewDetail,
        generalLookupsSys,
        checkReqFields,
      )
    }

    dispatch(destroyClientDependents())

    // return dispatch(
    //   fetchSFM({
    //     instanceName: SEARCH_CLIENT_FETCHER_NAME,
    //     callApi: Client.search,
    //     callApiArgs: getClientSearchData(cardNumberInput, productViewDetail),
    //     transformResponse: transformClientSearchData,
    //     resolve: (client) => {
    //       if (client !== null) {
    //         return fetchClientDependents(
    //           dispatch,
    //           client,
    //           Client_ReqField_GroupID,
    //           which,
    //           productViewDetail,
    //           generalLookupsSys,
    //         )
    //       }
    //     },
    //     reject: (err) => {
    //       dispatch(LKModalActions.openError(err.Error.Message || err.Error.Text))
    //     },
    //   }),
    // )

    //UPDATED API REQUEST 'client_search'
    const params = getClientSearchData(cardNumberInput, productViewDetail)
    try {
      const { payload } = await dispatch(clientSearch(params[0]))
      const client = transformClientSearchData({ Data: payload })
      if (client !== null) {
        return fetchClientDependents(
          dispatch,
          client,
          Client_ReqField_GroupID,
          which,
          productViewDetail,
          generalLookupsSys,
        )
      }
    } catch (err) {
      dispatch(LKModalActions.openError(err.Error.Message || err.Error.Text))
    }
  }
}

export const reduceClient = (
  dispatch,
  client,
  Client_ReqField_GroupID,
  which,
  productViewDetail,
  generalLookupsSys,
) => {
  dispatch(destroyClientDependents())

  fetchClientDependents(dispatch, client, Client_ReqField_GroupID, which, productViewDetail, generalLookupsSys)
}

// export const fetchCustomFieldsData = (ID, hash) =>
//   fetchSFM({
//     instanceName: APP_VIEW_CUSTOM_DYNAMIC_FIELD_FETCHER_NAME,
//     callApi: Application.details,
//     callApiArgs: [{ ID, hash, page: 'custfields' }],
//     transformResponse: (responseCustFields) => responseCustFields.Data,
//   })

//UPDATED API REQUEST application_view_api page: custfields
export const fetchCustomFieldsData = (ID, hash) =>
  applicationViewCustfields({
    AppID: ID,
    HashSum_AppID_: hash,
  })

export const openAppEditClientEditModal = ({
  clientID,
  hashSumClientID,
  clientType,
  clientReqFieldGroupID,
  appID,
  appHash,
  customFieldsCacheKey,
}) =>
  LKModalActions.openConfirmation(APP_EDIT_CLIENT_EDIT_MODAL_NAME, {
    message: translateLKMessage('ERR_FILL_REQUIRED_FIELDS'),
    ID: clientID,
    hash: hashSumClientID,
    ClientType: clientType,
    clientReqFieldGroupID,
    appID,
    appHash,
    customFieldsCacheKey,
  })

export const openAdd = () => {
  return async (dispatch) => {
    const productList = await dispatch(loadProductListIfNeeded())

    if (!isProductViewListValid(productList)) {
      dispatch(LKModalActions.close(APP_ADD_INSTANCE_NAME))
      return
    }

    const { ID, HashSum_ProductID_ } = first(productList)

    const customFieldsAttributes = {
      subGroupId: 1,
      groupId: CustomFieldsGroup.Application,
      productId: ID,
    }

    const customFieldsCacheKey = customFieldsAttributesToString(customFieldsAttributes)

    dispatch([
      loadProductDetailsIfNeeded({ productId: ID, productHash: HashSum_ProductID_ }),
      loadCustomFields({
        cacheKey: customFieldsCacheKey,
        ...customFieldsAttributes,
      }),
      LKModalActions.open({ name: APP_ADD_INSTANCE_NAME, customFieldsCacheKey }),
    ])
  }
}

export const openAppEdit = (ID, hash, checkIfEditable = true) => {
  return async (dispatch) => {
    loadingActions.start()

    // const {
    //   IsAppEditable,
    //   ProductID,
    //   ClientID,
    //   HashSum_ClientID_,
    //   ClientID2,
    //   HashSum_ClientID2_,
    //   ClientID3,
    //   HashSum_ClientID3_,
    //   ProductType,
    // } = await dispatch(
    //   fetchSFM({
    //     instanceName: APP_VIEW_BASE_FETCHER_NAME,
    //     callApi: Application.details,
    //     callApiArgs: [{ ID, hash, page: 'base' }],
    //     transformResponse: (response) => response.Data,
    //   }),
    // )

    //UPDATED API REQUEST application_view_api page: base
    const applicationViewBaseResult = await dispatch(
      applicationViewBase({
        AppID: ID,
        HashSum_AppID_: hash,
      }),
    )

    if (!applicationViewBase.fulfilled.match(applicationViewBaseResult)) {
      dispatch(LKModalActions.openError(translateLKMessage(applicationViewBaseResult.payload)))
      loadingActions.stop()
      return
    }

    const {
      IsAppEditable,
      ProductID,
      ClientID,
      HashSum_ClientID_,
      ClientID2,
      HashSum_ClientID2_,
      ClientID3,
      HashSum_ClientID3_,
      ProductType,
    } = applicationViewBaseResult.payload

    dispatch(change(FORM_NAME, 'ProductID', ProductID))

    const productList = await dispatch(loadProductListIfNeeded())

    if (!isProductViewListValid(productList)) {
      dispatch(LKModalActions.close(APP_EDIT_INSTANCE_NAME))
      return
    }

    let bicDetails = []

    if (ProductType === 5) {
      const { payload: bicData } = await dispatch(
        applicationViewBic({
          AppID: ID,
          HashSum_AppID_: hash,
        }),
      )

      bicDetails = castArray(bicData)
    }

    await dispatch(fetchCustomFieldsData(ID, hash))

    const customFieldsAttributes = {
      subGroupId: 1,
      groupId: CustomFieldsGroup.Application,
      productId: ProductID,
    }

    const customFieldsCacheKey = customFieldsAttributesToString(customFieldsAttributes)

    dispatch(
      loadCustomFields({
        cacheKey: customFieldsCacheKey,
        ...customFieldsAttributes,
      }),
    )

    if (checkIfEditable && IsAppEditable !== 1) {
      loadingActions.stop()

      dispatch(LKModalActions.openInfo(translateLKMessage('ERR_APP_EDIT_DECISION_TAKEN')))
    } else {
      const productView = find(productList, ['ID', ProductID])

      if (isUndefined(productView)) {
        loadingActions.stop()

        dispatch(LKModalActions.openInfo(translateLKMessage('ERR_PRODUCT_EXPIRED')))
      } else {
        const prodViewID = productView.ID
        const prodViewHash = productView.HashSum_ProductID_

        const prodViewDetail = await dispatch(
          loadProductDetailsIfNeeded({ productId: prodViewID, productHash: prodViewHash }),
        )

        Promise.all([
          // dispatch(fetchClientValidation(ClientID, HashSum_ClientID_, prodViewDetail.Client_ReqField_GroupID)).then(
          //   (clientValidation) => [prodViewDetail, clientValidation],
          // ),
          //UPDATED API REQUEST client_oper_api page: checkreqfields
          dispatch(fetchClientValidationNew(ClientID, HashSum_ClientID_, prodViewDetail.Client_ReqField_GroupID)).then(
            (clientValidation) => {
              if (!checkReqFieldsAction.fulfilled.match(clientValidation)) {
                loadingActions.stop()
                throw new Error(clientValidation.payload)
              }
              return [prodViewDetail, clientValidation.payload]
            },
          ),
          dispatch(fetchClientViewBase(ClientID, HashSum_ClientID_)),
          Number(ClientID2) ? dispatch(fetchClientViewBase(ClientID2, HashSum_ClientID2_, 2)) : Promise.resolve(),
          Number(ClientID3) ? dispatch(fetchClientViewBase(ClientID3, HashSum_ClientID3_, 3)) : Promise.resolve(),
        ])
          .then((data) => {
            const [[{ Client_ReqField_GroupID, Active }, clientValidation], { ClientTypeID, Black, Watched }] = data
            loadingActions.stop()

            if (Active !== 1) {
              dispatch(LKModalActions.openInfo(translateLKMessage('ERR_PRODUCT_EXPIRED')))
            } else if (Black === 1 || Watched === 1) {
              if (Black === 1 && Watched === 1) {
                dispatch(
                  LKModalActions.openInfo(
                    `${translateLKMessage('ERR_CLIENT_BLACKLISTED')} , \n${translateLKMessage('ERR_CLIENT_WATCHED')}`,
                  ),
                )
              } else if (Black === 1) {
                dispatch(LKModalActions.openInfo(translateLKMessage('ERR_CLIENT_BLACKLISTED')))
              } else {
                dispatch(
                  LKModalActions.openConfirmation(APP_EDIT_CLIENT_WATCHLIST_MODAL_NAME, {
                    message: `${translateLKMessage('ERR_CLIENT_WATCHED')}, ${translateLKMessage(
                      'CONFIRM_VALIDATION_WARNING_OVERRIDE',
                    )}`,
                    clientValidation,
                    clientID: ClientID,
                    hashSumClientID: HashSum_ClientID_,
                    clientType: ClientTypeID,
                    clientReqFieldGroupID: Client_ReqField_GroupID,
                    appID: ID,
                    appHash: hash,
                    bicDetails,
                    customFieldsCacheKey,
                  }),
                )
              }
            } else if (isClientViewBaseValidTest(clientValidation)) {
              dispatch(
                LKModalActions.open({
                  name: APP_EDIT_INSTANCE_NAME,
                  applicationIdentity: { ID, hash },
                  bicDetails,
                  customFieldsCacheKey,
                }),
              )
            } else {
              dispatch(
                openAppEditClientEditModal({
                  clientID: ClientID,
                  hashSumClientID: HashSum_ClientID_,
                  clientType: ClientTypeID,
                  clientReqFieldGroupID: Client_ReqField_GroupID,
                  appID: ID,
                  appHash: hash,
                  customFieldsCacheKey,
                }),
              )
            }
          })
          .catch((e) => {
            dispatch(LKModalActions.openError(translateLKMessage(e.message)))
          })
      }
    }
  }
}
